/* eslint-disable */

class bi9_branding_css {
  static bi9LoadCssFile(filename) {
    var fileref = document.createElement('link');
    fileref.setAttribute('rel', 'stylesheet');
    fileref.setAttribute('type', 'text/css');
    fileref.setAttribute('href', filename);

    if (typeof fileref !== 'undefined')
      try {
        document.getElementsByTagName('head')[0].appendChild(fileref);
      } catch (err) {
        console.log(err);
      }
  };

  static bi9LoadLessFile(filename) {
    var fileref = document.createElement('link');
    fileref.setAttribute('rel', 'stylesheet');
    fileref.setAttribute('type', 'text/less');
    fileref.setAttribute('href', filename);

    if (typeof fileref !== 'undefined')
      try {
        document.getElementsByTagName('head')[0].appendChild(fileref);
      } catch (err) { }
  };

  static bi9LoadSiteCssFile() {
    var brand_id = this.getBrandId();

    if (brand_id === '' ) { return; }
    bi9_branding_css.bi9LoadLessFile('/dynamic/css/' + brand_id + '/theme.less');
    bi9_branding_css.bi9LoadLessFile('/dynamic/css/' + brand_id + '/all.less');
  }
    

  static bi9LoadSiteTitle() {
    var brand_id = this.getBrandId();
    var brand_titles = {'b1': 'DGnet Watchdog', 'b2': 'DNG Avidex', 'b3': 'XYZ Integration','b4': 'Walmart IoT'}

    if (brand_id === '' || Object.keys(brand_titles).includes(brand_id) === false) { return; }

    var fileref = document.createElement('title');
    fileref.innerHTML = brand_titles[brand_id];

    if (typeof fileref !== 'undefined')
      try {
        document.getElementsByTagName('head')[0].appendChild(fileref);
      } catch (err) { }
  }
  
  static bi9LoadSiteIcon() {
    var brand_id = this.getBrandId();

    if (brand_id === '' ) { return; }

    var fileref = document.createElement('link');
    fileref.setAttribute('rel', 'shortcut icon');
    fileref.setAttribute('type', 'image/x-ico');
    fileref.setAttribute('href', `/dynamic/images/${brand_id}/browser_window_icon.ico`);

    if (typeof fileref !== 'undefined')
      try {
        document.getElementsByTagName('head')[0].appendChild(fileref);
      } catch (err) { }
  }

  static getBrandId() {
    var brand_id = '';

    var brands = {'localhost': 'b1',
                  '127.0.0.1': 'b1', 
                  'watchdog.dgnet.cloud': 'b1', 
                  'almo.cloud': 'b1',
                  '360service.avidex.cloud': 'b2',
                  'avidex.cloud': 'b2',
                  'whitelabel.dgnet.cloud': 'b3',
                  'walmartsystems.com' : 'b4'
                };

    for (var key in brands) {
      if (window.location.hostname.toLocaleLowerCase().indexOf(key) >= 0) {
        brand_id = brands[key]
        break;
      };
    };

    return brand_id;
  }

  // This brand color is being used in multiple places. 
  // Like loading indecator color, time-picker color according to brand.
  static getBrandColor() {
    var brand_id = this.getBrandId();

    switch(brand_id) {
        case 'b1':
          return '#1ca838';
        case 'b2':
          return '#1ca1ca';
        case 'b3':
          return '#027976';
        case 'b4':
          return '#0071ce';
        default:
          // Grey color if brand_id not found.
          return '#7e8489';
      }

  }
}

export default bi9_branding_css



// WEBPACK FOOTER //
// ./src/watchdog_includes/base_i9_branding_css.js